module.exports = require("history/createBrowserHistory");